
(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else fn();
  }

  ready(function () {
    const widget = document.querySelector(".stacked-subscription-widget");
    if (!widget) return;

    // Hide subscription selector (A/B test requirement)
    const style = document.createElement("style");
    style.textContent = `.stacked-subscription-widget .subscription-options{display:none!important;}`;
    document.head.appendChild(style);

    const productId = widget.dataset.productId;
    const purchaseRadios = widget.querySelectorAll(`input[name="purchase_${productId}"]`);
    const variantItems = Array.from(widget.querySelectorAll(".variant-options .option-item"));
    const subscriptionItems = Array.from(widget.querySelectorAll(".subscription-options .option-item"));
    const subscriptionPriceEl = widget.querySelector(".subscription-price");

    if (subscriptionItems.length === 0 || variantItems.length === 0) return;

    let currentType =
      widget.querySelector(`#purchase-subscription-${productId}`)?.checked
        ? "subscription"
        : "onetime";

    let currentVariantId =
      widget.dataset.defaultVariantId ||
      widget.querySelector(".variant-options .option-item.active")?.dataset.variantId ||
      (variantItems[0] ? variantItems[0].dataset.variantId : null);

    let currentSellingPlan = null;

    // -----------------------------
    // Money formatting
    // -----------------------------
    function formatMoney(cents) {
      const currency =
        window.Shopify?.currency?.active ? window.Shopify.currency.active : "DKK";

      let locale = "da-DK";
      if (currency === "EUR") locale = "de-DE";
      else if (currency === "GBP") locale = "en-GB";
      else if (currency === "USD") locale = "en-US";
      else if (currency === "PLN") locale = "pl-PL";

      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format((parseInt(cents || "0", 10) || 0) / 100);
    }

    function formatMoneyWithDecimals(cents, decimals) {
      const currency =
        window.Shopify?.currency?.active ? window.Shopify.currency.active : "DKK";

      let locale = "da-DK";
      if (currency === "EUR") locale = "de-DE";
      else if (currency === "GBP") locale = "en-GB";
      else if (currency === "USD") locale = "en-US";
      else if (currency === "PLN") locale = "pl-PL";

      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }).format((parseInt(cents || "0", 10) || 0) / 100);
    }

    function getDailyDivisor(optionItemEl, fallbackIndex) {
      const dailyPriceWrap = optionItemEl.querySelector(".price-per-day");
      const fromDataset = parseInt(dailyPriceWrap?.dataset?.dailyDivisor || "0", 10);
      if (fromDataset > 0) return fromDataset;

      if (fallbackIndex === 1) return 90;
      if (fallbackIndex === 2) return 180;
      return 30;
    }

    function updateDailyPriceUI(optionItemEl, totalCents, fallbackIndex) {
      const dailyPriceWrap = optionItemEl.querySelector(".price-per-day");
      const dailyPriceText = optionItemEl.querySelector(".daily-price-text");
      if (!dailyPriceWrap || !dailyPriceText) return;

      const divisor = getDailyDivisor(optionItemEl, fallbackIndex);
      if (!divisor || !totalCents) return;

      const dailyCents = Math.round(totalCents / divisor);
      dailyPriceWrap.dataset.dailyPrice = String(dailyCents);
      dailyPriceText.textContent = `${formatMoneyWithDecimals(dailyCents, 2)} / dag`;
    }

    function setActiveVariantUI(variantId) {
      variantItems.forEach((el) =>
        el.classList.toggle("active", el.dataset.variantId == variantId)
      );
    }

    function setActiveSubscriptionUI(planId) {
      subscriptionItems.forEach((el) =>
        el.classList.toggle("active", el.dataset.planId == planId)
      );
    }

    // -----------------------------
    // Price calculations
    // -----------------------------
    function computeSubscriptionPriceFromEl(itemEl) {
      if (!itemEl) return null;

      const basePrice = parseInt(itemEl.dataset.basePrice || "0", 10);
      const adjustment = parseInt(itemEl.dataset.priceAdjustment || "0", 10);
      const adjustmentType = itemEl.dataset.adjustmentType || "percentage";

      if (!basePrice) return null;

      if (adjustmentType === "percentage") {
        return Math.round(basePrice * (1 - adjustment / 100));
      }
      return Math.max(0, basePrice - adjustment);
    }

    function findBestPlanElForVariant(variantId) {
      if (!variantId) return subscriptionItems[0] || null;
      // prefer match by data-variant-id
      let match = subscriptionItems.find((el) => el.dataset.variantId == variantId);

      // fallback by index
      if (!match) {
        const idx = variantItems.findIndex((v) => v.dataset.variantId == variantId);
        if (idx >= 0 && subscriptionItems[idx]) match = subscriptionItems[idx];
      }

      return match || subscriptionItems[0] || null;
    }

    // ✅ Always update the subscription header based on current variant
    function syncSubscriptionHeaderToVariant(variantId) {
      if (!subscriptionPriceEl) return;

      const planEl = findBestPlanElForVariant(variantId);
      if (!planEl) return;

      const price = computeSubscriptionPriceFromEl(planEl);
      if (price === null) return;

      subscriptionPriceEl.textContent = formatMoney(price);

      // Only lock plan when subscription is selected
      if (currentType === "subscription") {
        currentSellingPlan = planEl.dataset.planId;
        setActiveSubscriptionUI(currentSellingPlan);
      }
    }

    // -----------------------------
    // ✅ NEW: Update variant option prices when subscription is selected
    // -----------------------------
    function cacheOriginalVariantPrices() {
      variantItems.forEach((v) => {
        // store original cents (one-time) once
        if (!v.dataset.originalPrice) {
          v.dataset.originalPrice = v.dataset.variantPrice || "";
        }
      });
    }

    // "spar X%" badge vs. compare-at price; with subscription selected it uses the
    // plan's first-order price, marked with * (test #93 winner).
    function updateDiscountBadge(optionItemEl, priceCents, isSubscription) {
      const badge = optionItemEl.querySelector(".test_discount_badge");
      if (!badge || !priceCents) return;

      const compare = parseInt(optionItemEl.dataset.comparePrice || "0", 10) || priceCents;
      const pct = Math.round(((compare - priceCents) / compare) * 100);

      if (pct > 0) {
        badge.textContent = `spar ${pct}%${isSubscription ? "*" : ""}`;
        badge.removeAttribute("hidden");
        badge.style.setProperty("display", "block", "important");
      } else {
        badge.style.setProperty("display", "none", "important");
      }
    }

    function applyOnetimePricesToVariantOptions() {
      variantItems.forEach((v, idx) => {
        const priceMain = v.querySelector(".price-main");
        if (!priceMain) return;

        const cents = parseInt(v.dataset.originalPrice || v.dataset.variantPrice || "0", 10);
        if (cents) {
          priceMain.textContent = formatMoney(cents);
          updateDailyPriceUI(v, cents, idx);
          updateDiscountBadge(v, cents, false);
        }
      });
    }

    function applySubscriptionPricesToVariantOptions() {
      variantItems.forEach((v, idx) => {
        const priceMain = v.querySelector(".price-main");
        if (!priceMain) return;

        const variantId = v.dataset.variantId;
        const planEl = findBestPlanElForVariant(variantId);
        const subCents = computeSubscriptionPriceFromEl(planEl);

        if (subCents !== null) {
          priceMain.textContent = formatMoney(subCents);
          updateDailyPriceUI(v, subCents, idx);
          updateDiscountBadge(v, subCents, true);
        }
      });
    }

    // -----------------------------
    // Init
    // -----------------------------
    cacheOriginalVariantPrices();

    if (currentVariantId) {
      setActiveVariantUI(currentVariantId);
      syncSubscriptionHeaderToVariant(currentVariantId);
    }

    // Ensure the first selector shows correct prices based on current type
    if (currentType === "subscription") {
      applySubscriptionPricesToVariantOptions();
      // also lock plan
      const planEl = findBestPlanElForVariant(currentVariantId);
      if (planEl) {
        currentSellingPlan = planEl.dataset.planId;
        setActiveSubscriptionUI(currentSellingPlan);
      }
    } else {
      applyOnetimePricesToVariantOptions();
    }

    // -----------------------------
    // Events
    // -----------------------------
    purchaseRadios.forEach((r) => {
      r.addEventListener("change", function () {
        currentType = this.value;

        if (!currentVariantId && variantItems[0]) {
          currentVariantId = variantItems[0].dataset.variantId;
        }

        if (currentVariantId) {
          setActiveVariantUI(currentVariantId);
          syncSubscriptionHeaderToVariant(currentVariantId);
        }

        if (currentType === "subscription") {
          // ✅ update option prices to subscription prices
          applySubscriptionPricesToVariantOptions();

          // lock selling plan for current variant
          const planEl = findBestPlanElForVariant(currentVariantId);
          if (planEl) {
            currentSellingPlan = planEl.dataset.planId;
            setActiveSubscriptionUI(currentSellingPlan);
          }
        } else {
          // ✅ revert option prices to one-time prices
          currentSellingPlan = null;
          applyOnetimePricesToVariantOptions();
        }
      });
    });

    variantItems.forEach((item) => {
      item.addEventListener("click", function () {
        currentVariantId = this.dataset.variantId;
        setActiveVariantUI(currentVariantId);

        // Always keep subscription header synced
        syncSubscriptionHeaderToVariant(currentVariantId);

        // If subscription selected, also keep prices in selector as subscription prices
        if (currentType === "subscription") {
          applySubscriptionPricesToVariantOptions();

          const planEl = findBestPlanElForVariant(currentVariantId);
          if (planEl) {
            currentSellingPlan = planEl.dataset.planId;
            setActiveSubscriptionUI(currentSellingPlan);
          }
        }
      });
    });

    // -----------------------------
    // Hijack add-to-cart to avoid old "choose plan" alert
    // -----------------------------
    document.addEventListener(
      "click",
      async function (e) {
        const btn = e.target.closest('button[name="add"]');
        if (!btn) return;

        const form = btn.closest("form");
        if (!form || !widget) return;

        if (!currentVariantId) return;

        if (currentType === "subscription") {
          const planEl = findBestPlanElForVariant(currentVariantId);
          if (planEl) {
            currentSellingPlan = planEl.dataset.planId;
            setActiveSubscriptionUI(currentSellingPlan);
          }
          if (!currentSellingPlan) return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        btn.style.opacity = "0.7";
        btn.style.pointerEvents = "none";

        const qtyInput =
          form.querySelector('input[name="quantity"]') ||
          document.querySelector('input[name="quantity"]');
        const quantity = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;

        const item = {
          id: currentVariantId,
          quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
        };

        if (currentType === "subscription") item.selling_plan = currentSellingPlan;

        // This capture-phase handler runs before (and stops) the checkbox
        // cross-sell and free-gift blocks' own button listeners, so add their
        // items in this same request instead of dropping them.
        const scope = widget.closest(".main-product") || document;
        const crossSellInputs = Array.from(
          scope.querySelectorAll('[data-checkbox-cross-sell] input[name="cross_sell_products[]"]:checked')
        ).filter(function (input) {
          const block = input.closest("[data-checkbox-cross-sell]");
          return block && block.getClientRects().length > 0;
        });
        const extraItems = crossSellInputs.map(function (input) {
          return { id: input.value, quantity: 1 };
        });
        scope.querySelectorAll('[data-free-gifts-block][data-auto-add="true"] [data-gift-variant-id]').forEach(function (gift) {
          extraItems.push({ id: gift.dataset.giftVariantId, quantity: 1 });
        });
        const pdpCrossSellItems =
          typeof window.getExtraCartItems === "function" ? window.getExtraCartItems() : [];

        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ items: [item].concat(extraItems, pdpCrossSellItems) }),
          });

          const data = await res.json();

          if (typeof Shopify !== "undefined" && Shopify.onItemAdded) {
            Shopify.onItemAdded(data);
          } else {
            document.dispatchEvent(new CustomEvent("cart:updated", { detail: data }));
          }

          if (res.ok) {
            crossSellInputs.forEach(function (input) {
              input.checked = false;
              input.dispatchEvent(new Event("change"));
            });
            if (pdpCrossSellItems.length && typeof window.resetExtraCartItems === "function") {
              window.resetExtraCartItems();
            }
          }
        } catch (err) {
          console.error("A/B add to cart error:", err);
          alert("Der opstod en fejl. Prøv igen.");
        } finally {
          btn.style.opacity = "1";
          btn.style.pointerEvents = "auto";
        }
      },
      true
    );
  });
})();